import React, { useEffect } from 'react';
import * as Sentry from '@sentry/react-native';
import Common from 'src/components/Common';
import { styles } from './style';
import { NoAppIdIcon } from 'src/assets/icons';
import { colors } from 'src/constants/theme';

const NoAppId = () => {
  useEffect(() => {
    Sentry.captureMessage('appId NOT provided!');
  }, []);

  return (
    <Common.View style={styles.noAppIdWrapper}>
      <Common.View>
        <NoAppIdIcon width={200} height={150} />
      </Common.View>
      <Common.Text size={20} style={{ margin: 20 }} bold>
        Account not linked
      </Common.Text>
      <Common.Text color={colors.grey8}>
        It looks like your account is not linked to an app id. Please reach out to your service provider and request
        access.
      </Common.Text>
    </Common.View>
  );
};

export default NoAppId;
